import React, { useEffect, useRef, useState } from "react";
import cn from "classnames";
import style from "./style.module.scss";
import { useClickOutside } from "../../../../hooks/useClickOutside";
import CustomInput from "../../../custom/custom-input/CustomInput";
import LupeIcon from "../../../shared/icons/LupeIcon";
import CustomButton from "../../../custom/custom-button/CustomButton";
import {t} from "i18next";

const AddAddress = ({
  labelText = "",
  placeholder,
  setAddress,
  errorText = "",
  isDisabled = false,
  country = "",
  city = "",
  address = "",
  setCoordinates,
}) => {
  const [inputValue, setInputValue] = useState(`${country}, ${city}, ${address}`);
  const [suggestions, setSuggestions] = useState([]);
  const [isShowSuggestions, setShowSuggestions] = useState(false);
  const [isLoading, setLoading] = useState(false);
  const [isSearch, setSearch] = useState(false);
  const suggestionsRef = useRef(null);

  const API_KEYS = {
    suggest: process.env.REACT_APP_GEOSUGGEST_API_KEY,
    geocode: process.env.REACT_APP_YMAPS_API_KEY,
  };

  useClickOutside(suggestionsRef, () => {
    setShowSuggestions(false);
  });

  useEffect(() => {
    setInputValue("");
    setInputValue(`${country}, ${city}, `);
    setSuggestions([]);
  }, [country, city]);

  const fetchSuggestions = async (query) => {
    setSearch(true);
    const url = `https://suggest-maps.yandex.ru/v1/suggest?apikey=${API_KEYS.suggest}&text=${query}&print_address=1&attrs=uri`;

    try {
      const response = await fetch(url);
      const data = await response.json();
      setSuggestions(data?.results || []);
      console.log("Подсказки:", data?.results);
      setSearch(false);
    } catch (error) {
      console.error("Ошибка при запросе подсказок:", error);
      setSearch(false);
    }
  };

  const fetchCoordinates = async (address) => {
    setLoading(true);
    const url = `https://geocode-maps.yandex.ru/1.x/?apikey=${
      API_KEYS.geocode
    }&geocode=${encodeURIComponent(address)}&format=json`;
    try {
      const response = await fetch(url);
      const data = await response.json();
      const point =
        data.response?.GeoObjectCollection?.featureMember?.[0]?.GeoObject?.Point?.pos;
      setLoading(false);
      if (point) {
        const [lng, lat] = point.split(" ");
        const coordinates = `${parseFloat(lat)},${parseFloat(lng)}`;
        setCoordinates(coordinates);
        console.log("setCoordinates", coordinates);
      } else {
        console.error("Координаты не найдены для адреса:", address);
      }
    } catch (error) {
      setLoading(false);
      console.error("Ошибка при запросе координат:", error);
    }
  };

  const handleInputChange = (value) => {
    setInputValue(value);
    setShowSuggestions(true);
  };

  const handleSuggestionClick = (suggestion) => {
    setShowSuggestions(false);
    setSuggestions([]);

    const components = suggestion.address?.component || [];
    const area = components.find((item) => item.kind.includes("AREA"))?.name || "";
    const locality =
      components.find((item) => item.kind.includes("LOCALITY"))?.name || "";
    const district =
      components.find((item) => item.kind.includes("DISTRICT"))?.name || "";
    const street = components.find((item) => item.kind.includes("STREET"))?.name || "";
    const house = components.find((item) => item.kind.includes("HOUSE"))?.name || "";

    let formattedInputValue;

    if (!district && !street && !house) {
      formattedInputValue = [area, locality, district, street, house].filter(Boolean).join(", ");
    } else {
      formattedInputValue = [district, street, house].filter(Boolean).join(", ");
    }

    setInputValue(suggestion.address?.formatted_address || "");
    setAddress(formattedInputValue || suggestion.title?.text);

    fetchCoordinates(suggestion.address?.formatted_address || "");
  };

  return (
    <>
      <div className={style.addAddressWrapper} onClick={() => setShowSuggestions(true)}>
        <CustomInput
          labelText={labelText}
          placeholder={placeholder}
          value={inputValue}
          isBgGray
          onChangeValue={handleInputChange}
          errorText={errorText}
          prefixStart={
            <LupeIcon
              onClick={() => {
                if (city) fetchSuggestions(inputValue);
              }}
              style={{ cursor: "pointer" }}
            />
          }
          isDisabled={isDisabled}
        />
        <CustomButton
          text={t('common.placeholder.search')}
          isDisabled={!city}
          onClick={() => fetchSuggestions(inputValue)}
          isLoading={isSearch || isLoading}
        />

        {isShowSuggestions && suggestions.length > 0 && (
          <ul className={style.suggestionsList} ref={suggestionsRef}>
            {suggestions.map((item, index) => (
              <li
                key={index}
                onClick={() => {
                  handleSuggestionClick(item);
                  setShowSuggestions(false);
                }}
              >
                <div>{item.title?.text}</div>
                <div style={{ fontSize: "14px" }}>{item.subtitle?.text}</div>
              </li>
            ))}
          </ul>
        )}
      </div>
    </>
  );
};

export default AddAddress;
